import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@shared-services/translate.service';

@Pipe({
  name: 'translate',
  pure: false
})

export class TranslatePipe implements PipeTransform
{
  constructor(private translate: TranslateService) { }

  public transform(_key: string = ''): string
  {
    return this.translate.getElement(_key);
  }
}
